var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriteGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9974 17.2755C12.8538 17.4191 12.659 17.4998 12.4559 17.4998C12.2528 17.4998 12.0581 17.4191 11.9145 17.2755L10.6998 16.0609C10.5562 15.9173 10.4756 15.7225 10.4756 15.5194C10.4756 15.3164 10.5562 15.1216 10.6998 14.978L14.9779 10.6999C15.1215 10.5564 15.3162 10.4757 15.5193 10.4757C15.7224 10.4757 15.9172 10.5564 16.0608 10.6999L17.2754 11.9146C17.419 12.0582 17.4997 12.253 17.4997 12.456C17.4997 12.6591 17.419 12.8539 17.2754 12.9975L12.9974 17.2755Z",
    stroke: "#4CAF50",
    strokeWidth: 1.37853,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7536 10.9244L13.7006 5.65991C13.6719 5.51668 13.6029 5.38463 13.5017 5.27933C13.4005 5.17403 13.2713 5.09987 13.1293 5.06561L3.44583 2.52145C3.31826 2.49061 3.18491 2.49306 3.05856 2.52859C2.93221 2.56411 2.81712 2.63151 2.72431 2.72431C2.63151 2.81712 2.56411 2.93221 2.52859 3.05856C2.49306 3.18491 2.49061 3.31826 2.52145 3.44583L5.06561 13.1293C5.09987 13.2713 5.17403 13.4005 5.27933 13.5017C5.38463 13.6029 5.51668 13.6719 5.65991 13.7006L10.9244 14.7536M2.72976 2.72976L8.30976 8.30976",
    stroke: "#4CAF50",
    strokeWidth: 1.37853,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39303 10.9242C10.239 10.9242 10.9247 10.2385 10.9247 9.39254C10.9247 8.54661 10.239 7.86084 9.39303 7.86084C8.5471 7.86084 7.86133 8.54661 7.86133 9.39254C7.86133 10.2385 8.5471 10.9242 9.39303 10.9242Z",
    stroke: "#4CAF50",
    strokeWidth: 1.37853,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteGreenIcon);
export default __webpack_public_path__ + "static/media/write-green-icon.678f79caff3c26b232085d950f04de6a.svg";
export { ForwardRef as ReactComponent };